import { Angle, Axis, Color3, Mesh, MeshBuilder, PhysicsAggregate, PhysicsShapeType, Quaternion, Scene, SceneLoader, Sound, Space, StandardMaterial, Texture, Vector3 } from "@babylonjs/core";
import '@babylonjs/loaders/OBJ/objFileLoader';
import boostTexture from "../../textures/boost_arrow.png"
import { Player } from "./Player";
import boostSfx from "../../sfx/boost.wav"

let _boostMaterial: StandardMaterial | null = null;
let _boostMesh: Mesh | null = null;
let _boostSound: Sound | null = null;
export class Boost {

  index: number;
  localPosition: Vector3;
  mesh: Mesh;
  height: number;
  width: number;
  boostMaterial: StandardMaterial;


  constructor(scene: Scene, index: number, position: Vector3) {
    this.localPosition = position;
    this.index = index;
    this.height = 20;
    this.width = 10;

    if (_boostMaterial == null) {
      _boostMaterial = new StandardMaterial("boostMaterial");
      // _boostMaterial.diffuseColor = Color3.Blue();
      _boostMaterial.diffuseTexture = new Texture(boostTexture, scene, false, false);
      _boostMaterial.useAlphaFromDiffuseTexture = true;
      _boostMaterial.diffuseTexture.hasAlpha = true;
      _boostMaterial.alphaCutOff = 0.5;
      _boostMaterial.transparencyMode = 3;
      _boostMaterial.alphaMode = 2;
      // _boostMaterial.alpha = .5;
      // (_boostMaterial.diffuseTexture as Texture).uScale = 0.4;
      // (_boostMaterial.diffuseTexture as Texture).vScale = 0.3;
    }
    this.boostMaterial = _boostMaterial;

    if (_boostMesh == null) {
      _boostMesh = MeshBuilder.CreateBox("_boost", { width: this.width, height: this.height, depth: 0.01 }, scene);
      _boostMesh.material = this.boostMaterial;
      _boostMesh.isVisible = false;
    }

    this.mesh = _boostMesh.clone();
    this.mesh.name = "boost" + index.toString().padStart(3, '0')
    this.mesh.isVisible = true;

    if (_boostSound == null) {
      _boostSound = new Sound("boostSfx", boostSfx, scene);
      _boostSound.loop = false;
    }
  }

  async init(scene: Scene) {
    this.mesh.rotate(Axis.X, Angle.FromDegrees(90).radians(), Space.LOCAL);
    this.mesh.rotate(Axis.Y, Angle.FromDegrees(180).radians(), Space.LOCAL);
    this.mesh.position = this.localPosition;
  }

  getHeight() {
    return this.height;
  }
  getWidth() {
    return this.width;
  }
  activate() {
    _boostSound?.play();
  }
}
